import { useEffect, useState } from "react"
import { object, func, string } from 'prop-types'
import { ServerRequest } from "../../../utils/apiweb"
import { REQUEST_METHOD } from '@laramie/ui';
import { APIS } from "../../../config/apis"
import { onRequestError, onRequestNoSuccess } from "../../../utils/requests"
import {TIPS} from "../../../consts/tips";


import { CheckboxButton, CheckboxButtonGroup, DatePickerCustom, FormError, FormLabel, InputLista, InputNumber, InputPercent, Modal, Select } from "../../common"
import { useForm, useFormErrors, useManagedContext } from "../../hooks"
import { isNull, isValidNumber } from "../../../utils/validator"
import { VALIDATION_MESSAGE } from "../../../consts/validationMessage"

const TipoRecargoDescuentoModal = (props) => {
    
    const entityInit = {
        id: -Date.now(),
        codigo: '',
        nombre: '',
        orden: '',
        tipo: '',
        idTipoTributo: 0,
        porcentaje: 0,
        importe: 0,
        emiteSolicitud: false,
        requiereOtorgamiento: false,
        fechaDesde: null,
        fechaHasta: null,
        procedimiento: '',
    }

    const { setIsLoading } = useManagedContext()

    const [entity, setEntity] = useState(entityInit)
    const [formValues, formHandle, _formReset, formSet] = useForm({
        codigo: '',
        nombre: '',
        orden: '',
        tipo: '',
        idTipoTributo: null,
        porcentaje: 0,
        importe: 0,
        emiteSolicitud: false,
        requiereOtorgamiento: false,
        fechaDesde: null,
        fechaHasta: null,
        procedimiento: ''
    })
    const [tipoValor, setTipoValor] = useState('porcentaje')


    useEffect(() => {
        const {
            codigo,
            nombre,
            orden,
            tipo,
            idTipoTributo,
            porcentaje,
            importe,
            emiteSolicitud,
            requiereOtorgamiento,
            fechaDesde,
            fechaHasta,
            procedimiento,
        } = props.editItem

        if (importe > 0) {
            setTipoValor('importe');
        }
        else {
            setTipoValor('porcentaje');
        }

        setEntity({ ...entityInit, ...props.editItem })
        formSet({
            codigo,
            nombre,
            orden,
            tipo,
            idTipoTributo,
            porcentaje,
            importe,
            emiteSolicitud,
            requiereOtorgamiento,
            fechaDesde,
            fechaHasta,
            procedimiento,
        })
    }, [props.editItem])

    const { errorOf, validate } = useFormErrors(getErrors, getFormatErrors)

    function getErrors() {
        const errors = {}

        if (formValues.codigo.length < 1) errors.codigo = VALIDATION_MESSAGE.REQUIRED
        if (formValues.nombre.length < 1) errors.nombre = VALIDATION_MESSAGE.REQUIRED
        if (isEmptyValue(formValues.orden)) errors.orden = VALIDATION_MESSAGE.REQUIRED
        if (isEmptyValue(formValues.tipo)) errors.tipo = VALIDATION_MESSAGE.REQUIRED
        if (tipoValor === 'porcentaje' && !isValidNumber(formValues.porcentaje, false)) errors.porcentaje = VALIDATION_MESSAGE.REQUIRED
        if (tipoValor === 'importe' && !isValidNumber(formValues.importe, false)) errors.importe = VALIDATION_MESSAGE.REQUIRED

        if (Number(formValues.porcentaje) === 0 && Number(formValues.importe) === 0) {
            if (tipoValor === 'porcentaje') errors.porcentaje = 'Debe ingresar importe o porcentaje'
            else errors.importe = 'Debe ingresar importe o porcentaje'
        }

        return errors
    }

    function getFormatErrors() {
        const errors = {}
        if (props.editMode === 'view') return errors

        if (!isEmptyValue(formValues.orden) && !isValidNumber(formValues.orden, true)) errors.orden = 'Ingresá un número mayor a cero'
        if (!isEmptyValue(formValues.tipo) && !isValidNumber(formValues.tipo, true)) errors.tipo = 'Ingresá un número mayor a cero'

        return errors
    }

    function isEmptyValue(valor) {
        return isNull(valor) || valor.toString().length === 0
    }

    const onClickConfirm = () => {
        if (!validate()) return

        setIsLoading(true)

        ServerRequest(
            props.editMode === 'add' ? REQUEST_METHOD.POST : REQUEST_METHOD.PUT,
            null,
            true,
            APIS.URLS.TIPO_RECARGO_DESCUENTO,
            props.editMode === 'modify' ? `/${entity.id}` : '',
            { ...entity, ...formValues, tipo: parseInt(formValues.tipo) ?? 0, orden: parseInt(formValues.orden) ?? 0 },
            res => res.json().then(() => {
                setIsLoading(false)
                props.onConfirm()
            }),
            res => {
                onRequestNoSuccess(res)
                setIsLoading(false)
            },
            error => {
                onRequestError(error)
                setIsLoading(false)
            },
        )
    }

    const disabled = props.editMode === 'view'

    return (
        <Modal
            size="xl"
            onEscape={props.onCancel}
            header={<h2 className="modal-title">Tipo recargo descuento: {(entity.id > 0) ? entity.nombre : "Nuevo"}</h2>}
            tipName={TIPS.NAME.MODALS.ENTIDAD_MODAL}
            body={(
                <div className="row form-basic">
                    <div className="col-12 col-md-3">
                        <FormLabel htmlFor="codigo" required>Código</FormLabel>
                        <input
                            type="text"
                            name="codigo"
                            maxLength={50}
                            className={`form-control ${errorOf('codigo') ? 'is-invalid' : ''}`}
                            value={formValues.codigo}
                            onChange={formHandle}
                            disabled={disabled}
                        />
                        <FormError message={errorOf('codigo')} />
                    </div>
                    <div className="col-12 col-md-5">
                        <FormLabel htmlFor="nombre" required>Nombre</FormLabel>
                        <input
                            type="text"
                            name="nombre"
                            className={`form-control ${errorOf('nombre') ? 'is-invalid' : ''}`}
                            value={formValues.nombre}
                            onChange={formHandle}
                            disabled={disabled}
                        />
                        <FormError message={errorOf('nombre')} />
                    </div>
                    <div className="col-12 col-md-2">
                        <FormLabel htmlFor="orden" required>Orden</FormLabel>
                        <input
                          name="orden"
						  type="number"
						  placeholder=""
						  className={`form-control ${errorOf('orden') ? 'is-invalid' : ''}`}
						  value={formValues.orden}
						  onChange={formHandle}
						  disabled={disabled}
                        />
                        <FormError message={errorOf('orden')} />
                    </div>

                    <div className="col-12 col-md-6 col-lg-2">
                        <FormLabel htmlFor="tipo" required>Tipo</FormLabel>
                        <input
                          name="tipo"
						  type="number"
						  placeholder=""
						  className={`form-control ${errorOf('tipo') ? 'is-invalid' : ''}`}
						  value={formValues.tipo}
						  onChange={formHandle}
						  disabled={disabled}
                        />
                        <FormError message={errorOf('tipo')} />
                    </div>
                    <div className="mb-3 col-12 col-md-3">
						<label htmlFor="esEmbarcacion" className="form-label">Tipo tributo</label>
                            <InputLista
                                name="idTipoTributo"
                                placeholder=""
                                className="form-control"
                                lista="TipoTributo"
                                textItemZero="Todos los tributos"
                                value={formValues.idTipoTributo}
                                onChange={formHandle}
                                disabled={disabled}
                            />
                            <FormError />
					</div>

                    <div className="mb-3 col-12 col-md-3">
						<label htmlFor="tipoValor" className="form-label">Tipo valor</label>
                        <Select
                            name='tipoValor'
                            className="form-control"
                            value={tipoValor}
                            onChange={({ target }) => {
                                setTipoValor(target.value)
                                formSet({
                                    ...formValues,
                                    porcentaje: 0,
                                    importe: 0,
                                })
                            }}
                            options={[{value: 'porcentaje', label: 'Porcentaje'}, {value: 'importe', label: 'Importe'}]}
                            disabled={disabled}
                        />
                        <FormError />
					</div>
                    {tipoValor === 'porcentaje' ? (
                        <div className="col-12 col-md-2">
                            <FormLabel htmlFor="orden" required={tipoValor === 'porcentaje'}>Porcentaje</FormLabel>
                            <InputPercent
                                name="porcentaje"
                                placeholder=""
                                className={`form-control ${errorOf('porcentaje') ? 'is-invalid' : ''}`}
                                value={formValues.porcentaje}
                                onChange={formHandle}
                                disabled={disabled}
                            />
                            <FormError message={errorOf('porcentaje')} />
                        </div>
                    ) : (
                        <div className="col-12 col-md-2">
                            <FormLabel htmlFor="importe" required={tipoValor === 'importe'}>Importe</FormLabel>
                            <InputNumber
                                name="importe"
                                placeholder=""
                                className={`form-control ${errorOf('importe') ? 'is-invalid' : ''}`}
                                value={formValues.importe}
                                precision={2}
                                onChange={formHandle}
                                validation={value => value >= 0}
                                disabled={disabled}
                            />
                            <FormError message={errorOf('importe')} />
                        </div>
                    )}

                    <div className="col-12 col-md-4">
                        <FormLabel htmlFor="procedimiento">Procedimiento</FormLabel>
                        <input
                          name="procedimiento"
						  type="text"
						  placeholder=""
						  className="form-control"
						  value={formValues.procedimiento}
						  onChange={formHandle}
						  disabled={disabled}
                        />
                        <FormError />
                    </div>

                    <div className="col-12 col-md-3">
                        <label htmlFor="fechaDesde" className="form-label">Fecha desde</label>
                        <DatePickerCustom
                            name="fechaDesde"
                            placeholder=""
                            className="form-control"
                            value={formValues.fechaDesde}
                            onChange={formHandle}
                            disabled={disabled}
                        />
                        <FormError />
                    </div>
                    <div className="col-12 col-md-3">
                        <label htmlFor="fechaHasta" className="form-label">Fecha hasta</label>
                        <DatePickerCustom
                            name="fechaHasta"
                            placeholder=""
                            className="form-control"
                            value={formValues.fechaHasta}
                            onChange={formHandle}
                            disabled={disabled}
                            minValue={formValues.fechaDesde}
                        />
                        <FormError />
                    </div>
                    <div className="mb-3 col-12 col-md-6">
                        <CheckboxButtonGroup label="Proceso">
                            <CheckboxButton
                                name="emiteSolicitud"
                                label="Emite solicitud"
                                checked={formValues.emiteSolicitud}
                                onChange={formHandle}
                                disabled={disabled}
                            />
                            <CheckboxButton
                                name="requiereOtorgamiento"
                                label="Requiere otorgamiento"
                                checked={formValues.requiereOtorgamiento}
                                onChange={formHandle}
                                disabled={disabled}
                            />
                        </CheckboxButtonGroup>
                    </div>
                </div>
            )}
            footer={(
                <div className="width-100p disp-b">
                    <button className="btn back-button m-left-5" data-dismiss="modal" onClick={props.onCancel}>Volver</button>
                    {props.editMode !== 'view' && (
                        <button className="btn action-button" data-dismiss="modal" onClick={onClickConfirm}>Guardar</button>
                    )}
                </div>
            )}
        />
    )
}

TipoRecargoDescuentoModal.propTypes = {
    editItem: object.isRequired,
    editMode: string,
    onConfirm: func.isRequired,
    onCancel: func.isRequired,
};

TipoRecargoDescuentoModal.defaultProps = {
    editMode: 'view'
};

export default TipoRecargoDescuentoModal
